import { type ReactNode, useState } from "react";

import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import IconButton from "@mui/material/IconButton";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import Toolbar from "@mui/material/Toolbar";

import { GoBackButton } from "@covertree/ui";
import CloseIcon from "./CloseIcon";
import MenuIcon from "./MenuIcon";

export interface MobileTopBarProps {
  search?: ReactNode;
  showBackButton?: boolean;
  sidebar: ReactNode;
  logo: ReactNode;
}

export const MobileTopBar = ({
  sidebar,
  search,
  showBackButton,
  logo,
}: MobileTopBarProps) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <>
      <AppBar
        variant="outlined"
        color="transparent"
        position="fixed"
        sx={{
          backgroundColor: "#fff",
          paddingY: 1,
          zIndex: 1100,
        }}>
        <Container component={(props) => <Toolbar {...props} />}>
          {showBackButton && !isMenuOpen && (
            <GoBackButton
              showLabel={false}
              buttonStyles={{
                position: "absolute",
                left: 16,
                top: "50%",
                transform: "translateY(-50%)",
                justifyContent: "flex-start",
              }}
            />
          )}
          <IconButton
            onClick={() => setIsMenuOpen((prevIsMenuOpen) => !prevIsMenuOpen)}
            sx={{
              position: "absolute",
              top: "50%",
              transform: "translateY(-50%)",
              ...(search ? { left: 16 } : { right: 16 }),
            }}>
            {isMenuOpen ? (
              <CloseIcon sx={{ fontSize: "2.5rem" }} />
            ) : (
              <MenuIcon sx={{ fontSize: "2.5rem" }} />
            )}
          </IconButton>
          <Box
            margin="auto"
            width={56}
            sx={{
              "& > svg": {
                width: 56,
                height: 56,
              },
            }}>
            {logo}
          </Box>
          {search}
        </Container>
      </AppBar>
      <SwipeableDrawer
        open={isMenuOpen}
        BackdropProps={{ invisible: true }}
        onOpen={() => setIsMenuOpen(true)}
        onClose={() => setIsMenuOpen(false)}
        sx={{
          zIndex: 1050,
          "& .MuiPaper-root": {
            paddingTop: 10,
            width: "100%",
            boxShadow: "none",
          },
        }}>
        {sidebar}
      </SwipeableDrawer>
      <Toolbar
        sx={{
          height: 90,
        }}
      />
    </>
  );
};

export default MobileTopBar;
